'use strict';

var copy = require('shallow-copy');
var find = require('lodash.find');

var salaryRangeRegex = /^(\d{1,6})?\-(\d{1,6})?$/;

var getSalaryRangeValues = function getSalaryRangeValues(salaryRange, minValue, maxValue) {
  if (!salaryRangeRegex.test(salaryRange)) {
    return [minValue, maxValue];
  }

  var matches = salaryRange.match(salaryRangeRegex);

  return [typeof matches[1] !== 'undefined' ? matches[1] : minValue, typeof matches[2] !== 'undefined' ? matches[2] : maxValue];
};

var refine = function refine(salaries, params) {
  var activeSalaryTypeValue = params.salarytype || salaries.defaultValue;
  var defaultSalaryType = salaries.options[0];
  var activeSalaryType = find(salaries.options, function (option) {
    return option.value.toLowerCase() === activeSalaryTypeValue.toLowerCase();
  }) || defaultSalaryType;

  var minValue = activeSalaryType.options[0].value;
  var maxValue = activeSalaryType.options[activeSalaryType.options.length - 1].value;

  var salaryRangeValues = getSalaryRangeValues(params.salaryrange, minValue, maxValue);
  var salaryFrom = salaryRangeValues[0];
  var salaryTo = salaryRangeValues[1];

  return {
    salary: {
      types: salaries.options.map(function (salary) {
        var newSalaryType = {
          label: salary.label,
          value: salary.value,
          isActive: activeSalaryType.value === salary.value
        };

        if (!newSalaryType.isActive) {
          newSalaryType.refineParams = copy(params);
          newSalaryType.refineParams.salarytype = salary.value;
          delete newSalaryType.refineParams.salaryrange;
        }

        return newSalaryType;
      }),
      from: activeSalaryType.options.filter(function (option) {
        return option.value !== maxValue;
      }).map(function (option) {
        var newOption = {
          label: option.label,
          value: option.value,
          isActive: salaryFrom === option.value
        };

        if (!newOption.isActive && parseInt(salaryTo, 10) > parseInt(option.value, 10)) {
          newOption.refineParams = copy(params);
          newOption.refineParams.salarytype = activeSalaryType.value;
          newOption.refineParams.salaryrange = option.value + '-' + salaryTo;
        }

        return newOption;
      }),
      to: activeSalaryType.options.filter(function (option) {
        return option.value !== minValue;
      }).map(function (option) {
        var newOption = {
          label: option.label,
          value: option.value,
          isActive: salaryTo === option.value
        };

        if (!newOption.isActive && parseInt(salaryFrom, 10) < parseInt(option.value, 10)) {
          newOption.refineParams = copy(params);
          newOption.refineParams.salarytype = activeSalaryType.value;
          newOption.refineParams.salaryrange = salaryFrom + '-' + option.value;
        }

        return newOption;
      })
    }
  };
};

module.exports = refine;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-refine-job-search/dist/refinements/salary.js
 ** module id = 494
 ** module chunks = 0
 **/